import _ from '../../core/utils'
const filterGridConfig = {
    el: _.select( '.besa__filter-grid' ),
    initialDisplayLength: 18,
    itemsLoadScrollOffset: 50
}

export default filterGridConfig